import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { CustomerItem, TypeaheadService } from '../../../services/typeahead.service';

@Component({
  selector: 'tt-order-head-copy',
  templateUrl: './order-head-copy.component.html',
  styleUrls: ['./order-head-copy.component.css']
})
export class OrderHeadCopyComponent implements OnInit {
    orderInternalNo;

    public copy?: Copy;

    public selectListOrderTypes: OrderTypeItem[] = [];

    public copying = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService, private typeahead: TypeaheadService) {
        this.orderInternalNo = this.stateService.getStateParams()['order_internal_no'];
    }

    private async loadCopy() {
        if (!!this.orderInternalNo) {
            this.copy = (await this.datatask.Post(1783, { order_internal_no: this.orderInternalNo }))[0];
        }
    }

    private async loadOrderTypes() {
        if (!this.copy) return;

        return this.selectListOrderTypes = await this.datatask.Post(612, { ordertype_id: this.copy!.ordertype_id_new });
    }

    public searchStatCustNames = () => {
        return this.typeahead.searchCustomer({
            cust_name: this.copy!.stat_cust_name,
            custtype: 'C',
            lastselect: 'SEARCH'
        });
    }

    public onStatCustNameSelected(event?: CustomerItem) {
        if (!this.copy) return;

        this.copy.stat_cust_no = !!event ? '' + event.item_id : '0';
        this.copy.stat_cust_name = event?.item_name ?? '';
    }

    public async copyChanges() {
        if (!!this.copy) {
            try {
                this.copying = true;

                const response = (await this.datatask.Post(1784, this.copy))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    if (response?.follow > 0 && response?.order_internal_no_new > 0) {
                        this.stateService.go('orderhead', { order_internal_no: response?.order_internal_no_new });
                    } else {
                        this.stateService.back();
                    }
                }
            } finally {
                this.copying = false;
            }
        }
    }

    private async init() {
        await this.loadCopy();
        this.loadOrderTypes();
    }

    ngOnInit() {
        this.init();
    }
}

interface Copy {
    order_internal_no: string;
    order_order_no: string;
    stat_cust_no: string;
    stat_cust_name: string;
    reverse_quantity: string;
    ordertype_id_new: string;
    update_price_from_pricelist: string;
    show_setting: string;
}

interface OrderTypeItem {
    ordertype_id: string;
    ordertype_name: string;
    orderby: number;
}
